// extracted by mini-css-extract-plugin
export default {"oldImageContainer":"style_oldImageContainer__fWMXS","p0":"style_p0__8TUK6","imageIcon":"style_imageIcon__LYsvP"};